import { Badge, Box, Text } from '@chakra-ui/react'
import {
  AudioOnlyReason,
  audioOnlyReasonChartText,
  FieldMapValue,
  getDateTimeString,
  visitLocationField,
} from '@hb/shared'
import { DataView } from '@components/DataView/DataView'

export const VisitLocationView = ({ data }: { data: FieldMapValue }) => {
  const visitLocation = data?.visitLocation as Record<string, any> | undefined
  const audioOnlyReason = visitLocation?.audioOnlyReason as AudioOnlyReason | undefined
  const telehealthAcknowledgedAt = visitLocation?.telehealthAcknowledgedAt as string | undefined

  return (
    <Box w="100%">
      <DataView
        noHeader
        alwaysExpanded
        field={visitLocationField}
        data={visitLocation ?? {}}
        boxProps={{ border: 'none', borderBottom: 'none' }}
      />
      {audioOnlyReason && audioOnlyReason !== 'other' ? (
        <Box
          mt={2}
          mb={1}
          px={3}
          py={2}
          bg="blue.50"
          borderLeft="3px solid"
          borderColor="blue.400"
          borderRadius={4}>
          <Text fontSize="sm" color="blue.700" fontStyle="italic">
            {audioOnlyReasonChartText[audioOnlyReason]}
          </Text>
        </Box>
      ) : null}
      {audioOnlyReason === 'other' ? (
        <Box
          mt={2}
          mb={1}
          px={3}
          py={2}
          bg="orange.50"
          borderLeft="3px solid"
          borderColor="orange.400"
          borderRadius={4}>
          <Text fontSize="sm" color="orange.700" fontWeight={600}>
            Note: Free-text audio-only justifications carry higher audit risk.
          </Text>
        </Box>
      ) : null}
      {telehealthAcknowledgedAt ? (
        <Box mt={2} mb={1} px={3} py={2}>
          <Badge colorScheme="green" fontSize="xs">
            Telehealth visit confirmed —{' '}
            {getDateTimeString(new Date(telehealthAcknowledgedAt).getTime(), 'long')}
          </Badge>
        </Box>
      ) : null}
    </Box>
  )
}
